import api from './api';

export async function uploadProducts(file, fileType, fileDescription, referenceDate, supplierId, supplierName, userName) {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('file_type', fileType);
  fd.append('file_description', fileDescription);
  fd.append('reference_date', referenceDate);
  fd.append('supplier_id', supplierId);
  fd.append('supplier_name', supplierName);
  if (userName) fd.append('user_name', userName);
  const { data } = await api.post('/api/upload-products', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}
